import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import CurFt from "../../components/CurFt";
import FlightProposalShare from "../../components/FlightProposalShare";
import {
  BaggageClaim,
  TicketX,
  TicketCheck,
  Ticket,
  Utensils,
  Gift,
} from "lucide-react";
import Filters from "./Filters";
import { toast } from 'react-hot-toast';
/* --- radio pill used on cards --- */
const SelectDot = ({ selected }) => (
  <div
    className={[
      "w-8 h-8 rounded-full border-2 flex items-center justify-center",
      selected ? "border-blue-600" : "border-gray-300",
    ].join(" ")}
  >
    <div
      className={[
        "w-3 h-3 rounded-full",
        selected ? "bg-blue-600" : "bg-transparent",
      ].join(" ")}
    />
  </div>
);

export default function RoundTripResultsPage(props) {
  const {
    outbound,
    inbound,
    FormData,
    handleBookNow,
    handlFlightDeatils,
    FiltStop,
    applyFilters,
    handleChangeStopsInbound,
    setPriceRange,
    priceRangeFilter,
    PriceRange,
    FiltPrice,
    FiltAirline,
    handleChangeStops,
    handleChangeAirlinesInbound,
    handleChangeAirlines,
    selectedDeparture,
    selectedDepartureInbound,
    selectedArrival,
    selectedArrivalInbound,
    handleChangeDepartureInbound,
    handleChangeArrivalInbound,
    handleChangeArrival,
    handleChangeDeparture,
    showSpecialReturn,
    setShowSpecialReturn,
    handleAirlineNameSSP,
    FiltAirlineSSP,
    handleChangeFarepol,
    selectedFarepol,
    handleFareClassInbound,
    FiltFareClassInbound,
    FiltFareClassOutbound,
    handleFareClassOutbound,
    user,
    onShare,
    onSetShare,
  } = props
  // const [selOnward, setSelOnward] = useState(outbound[0] || null);

  const [selOnward, setSelOnward] = useState({
    flight: outbound[0],
    price: outbound[0]?.FareList[0],
  });
  const [selReturn, setSelReturn] = useState({
    flight: inbound[0],
    price: inbound[0]?.FareList[0],
  });
  // const [selReturn, setSelReturn] = useState(inbound[0] || null);
  const totalFare =
    (selOnward?.price?.PublishedFare || 0) + (selReturn?.price?.PublishedFare || 0);
  const [openEye, setOpenEye] = useState(false);
  const [showProposalPopup, setshowProposalPopup] = useState(false);
  useEffect(() => {
    if (selectedFlights.length === 0 && onShare) {
      setshowProposalPopup(false)
      onSetShare(false)
      toast.error('Select atleast 1 flight', { autoClose: 3000 });
    } else {
      setshowProposalPopup(onShare)
    }
  }, [onShare]);
  const [selectedFlights, setSelectedFlights] = useState([]);

  const handleShareSelection = (flight, PriceID, isSelected) => {

    if (isSelected) {
      // Find the selected fare based on PriceID
      const selectedFare = flight.FareList?.find(
        fare => fare.PriceID === PriceID
      );

      if (!selectedFare) {
        console.log("Fare not found for PriceID:", PriceID);
        return;
      }

      // Store flight + selected fare
      const selectedFlight = {
        ...flight,
        FareList: [selectedFare],
        selectedPriceID: PriceID,
      };

      setSelectedFlights(prev => [...prev, selectedFlight]);
    } else {
      setSelectedFlights(prev =>
        prev.filter(f => f.selectedPriceID !== PriceID)
      );
    }
  };

  const isFlightSelected = (flight, PriceID) => {
    return selectedFlights.some(
      f =>
        f.keyIndex === flight.keyIndex &&
        f.selectedPriceID === PriceID
    );
  };

  return (
    <div className="flex flex-col md:flex-row gap-4">
      {/* LEFT FILTERS (same look as one-way) */}
      <Filters
        FormData={FormData}
        openEye={openEye}
        setOpenEye={setOpenEye}
        data={outbound}
        FiltStop={FiltStop}
        handleChangeStopsInbound={handleChangeStopsInbound}
        applyFilters={applyFilters}
        setPriceRange={setPriceRange}
        priceRangeFilter={priceRangeFilter}
        PriceRange={PriceRange}
        FiltPrice={FiltPrice}
        FiltAirline={FiltAirline}
        handleChangeStops={handleChangeStops}
        handleChangeAirlinesInbound={handleChangeAirlinesInbound}
        handleChangeAirlines={handleChangeAirlines}
        selectedDeparture={selectedDeparture}
        selectedDepartureInbound={selectedDepartureInbound}
        selectedArrival={selectedArrival}
        selectedArrivalInbound={selectedArrivalInbound}
        handleChangeDepartureInbound={handleChangeDepartureInbound}
        handleChangeArrivalInbound={handleChangeArrivalInbound}
        handleChangeArrival={handleChangeArrival}
        handleChangeDeparture={handleChangeDeparture}
        showSpecialReturn={showSpecialReturn}
        setShowSpecialReturn={setShowSpecialReturn}
        FiltAirlineSSP={FiltAirlineSSP}
        handleAirlineNameSSP={handleAirlineNameSSP}
        handleChangeFarepol={handleChangeFarepol}
        selectedFarepol={selectedFarepol}
        handleFareClassInbound={handleFareClassInbound}
        FiltFareClassInbound={FiltFareClassInbound}
        FiltFareClassOutbound={FiltFareClassOutbound}
        handleFareClassOutbound={handleFareClassOutbound}
      />

      {/* RIGHT: TWO COLUMNS (Onward / Return) */}
      <main className="w-full md:w-3/4 grid grid-cols-1 lg:grid-cols-2 gap-2">
        {showProposalPopup && selectedFlights.length > 0 && (
          <FlightProposalShare
            selectedFlights={selectedFlights}
            setSelectedFlights={setSelectedFlights}
            handleShareSelection={handleShareSelection}
            FormData={FormData}
            setshowProposalPopup={setshowProposalPopup}
            onSetShare={onSetShare}
            user={user}
          />
        )}
        {/* Onward Column */}
        <section>
          <HeaderRow />
          <div className="space-y-4">
            {outbound.map((f, keys) => (
              <FlightCard
                keys={keys}
                key={f.keyIndex}
                flight={f}
                selected={selOnward?.price}
                onSelect={setSelOnward}
                handlFlightDeatils={handlFlightDeatils}
                handleShareSelection={handleShareSelection}
                isFlightSelected={isFlightSelected}
                FormData={FormData}
              />
            ))}

            {
              outbound.length == 0 && (
                <div
                  className="h-10 flex items-center justify-center text-gray-500 ssssss"
                >
                  No Flight Found
                </div>
              )
            }
          </div >
        </section >

        {/* Return Column */}
        < section >
          <HeaderRow />
          <div className="space-y-4">
            {inbound.map((f, keys) => (
              <FlightCard
                keys={keys}
                key={f.keyIndex}
                flight={f}
                selected={selReturn?.price}
                onSelect={setSelReturn}
                handlFlightDeatils={handlFlightDeatils}
                handleShareSelection={handleShareSelection}
                isFlightSelected={isFlightSelected}
                FormData={FormData}
              />
            ))}
            {
              inbound.length == 0 && (
                <div
                  className="h-10 flex items-center justify-center text-gray-500 ssssss"
                >
                  No Flight Found
                </div>
              )
            }
          </div >
        </section >
      </main >

      {/* BOTTOM BAR: appears only when BOTH are selected */}
      {
        selOnward && selReturn && (
          <div className="fixed bottom-0 left-0 right-0 bg-[#0f172a] text-white z-50">
            <div className="max-w-[1400px] mx-auto px-4 py-3 flex items-center justify-center gap-6 overflow-x-auto">
              {/* Onward */}
              <BottomTile f={selOnward} FormData={FormData} />
              <span className="text-gray-400">|</span>

              {/* Return */}
              <BottomTile f={selReturn} FormData={FormData} />
              <span className="text-gray-400">|</span>

              {/* Total + CTA */}
              <div className="flex items-center gap-4 shrink-0">
                {FormData.GroupRequest !== true && (
                  <p className="text-2xl font-extrabold"><CurFt currency={selOnward.price.symbol || "INR"} price={totalFare} /></p>
                )}
                <button
                  onClick={() => handleBookNow(selOnward.flight, selOnward.price, selReturn.price, selReturn.flight)}
                  className="bg-blue-500 hover:bg-blue-600 text-white font-bold px-6 py-2 rounded-md"
                  type="button"
                >
                  {FormData.GroupRequest !== true ? 'BOOK' : 'REQUEST'}
                </button>
              </div>
            </div>
          </div>
        )
      }
    </div >
  );
}

/* ---- subcomponents ---- */

function HeaderRow() {
  return (
    <div className="hidden md:grid grid-cols-12 px-4 py-2 text-sm font-semibold text-gray-700">
      <div className="col-span-4">Airline</div>
      <div className="col-span-2">Departure</div>
      <div className="col-span-2">Duration</div>
      <div className="col-span-2">Arrival</div>
      <div className="col-span-2 text-right pr-2">Price</div>
    </div>
  );
}

function FlightCard({ keys, flight, selected, onSelect, handlFlightDeatils, handleShareSelection, isFlightSelected, FormData }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="bg-white rounded-lg shadow p-4 "

    >
      <div className="grid grid-cols-12 items-center gap-2">
        {/* Airline */}
        <div className="col-span-12 md:col-span-4 flex items-center gap-3">
          <div className="flex items-center border rounded-lg hover:bg-gray-50">
            <input
              checked={isFlightSelected(flight, flight.FareList[0]?.PriceID)}
              value="1"
              type="checkbox"
              onClick={() => handleShareSelection(flight, flight.FareList[0].PriceID, !isFlightSelected(flight, flight.FareList[0]?.PriceID))}
              className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
          </div>
          <div className="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 flex items-center justify-center p-1">
            <img src={flight.logo} alt={flight.AirlineName} className="object-contain rounded-md w-full h-full" />
          </div>
          <div>
            <p className="font-medium leading-5">{flight.AirlineName}</p>
            <p className="text-xs text-gray-600">{flight.FlightNumber}</p>
          </div>
        </div>

        {/* Departure */}
        <div className="col-span-4 md:col-span-2 text-center md:text-left">
          <p className="text-2x2 font-bold leading-6">{format(new Date(flight.FromUTCTime), "HH:mm")}</p>
          <p className="text-sm text-gray-600">{flight.SoCode} </p>
        </div>

        {/* Duration */}
        <div className="col-span-4 md:col-span-2 text-center md:text-left">
          <p className="font-medium">{flight.Duration}</p>
          <p className="text-sm text-gray-600">{flight.StopCount}</p>
        </div>

        {/* Arrival */}
        <div className="col-span-4 md:col-span-2 text-center md:text-left">
          <p className="text-2x2 font-bold leading-6">{format(new Date(flight.ToUTCTime), "HH:mm")}</p>
          <p className="text-sm text-gray-600">{flight.DeCode}</p>
        </div>

        {/* Price + radio */}
        <div className="col-span-12 md:col-span-2 flex items-center justify-between md:justify-end gap-3 cursor-pointer"
          onClick={() => onSelect({ flight, price: flight.FareList[0] })}
          role="button"
        >
          {FormData.GroupRequest !== true && (
            <p className="text-2x2 font-bold text-right">
              {flight.FareList[0].symbol} {flight?.FareList[0].PublishedFare}
              {/* <CurFt currency={flight.FareList[0].symbol || "INR"} price={flight?.FareList[0].PublishedFare} /> */}
              {flight?.FareList[0]?.discountOffline > 0 && (
                <>
                  <span className="inline-flex font-normal line-through items-center gap-2 text-sm text-red-600">
                    {(flight?.FareList[0].PublishedFare + flight?.FareList[0]?.discountOffline)}
                  </span>
                  <br />
                </>
              )}
            </p>
          )}

          <SelectDot selected={selected?.PriceID === flight?.FareList[0]?.PriceID} />
        </div>
      </div>

      {/* info row */}
      <div className="mt-3 flex items-center justify-between flex-wrap gap-2  grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
        <div className="flex items-center gap-2 flex-wrap col-span-3">
          {/* baggage */}
          <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
            <Ticket size={16} className="text-blue-600" />
            <span className="text-gray-700">
              {flight.FareList[0].fareIdentifier}
            </span>
          </span>
          <span className="inline-flex items-center gap-2 rounded-lg px-3 py-1 text-sm bg-white border">
            <BaggageClaim size={16} className="text-gray-700" />
            <span className="text-gray-700">{flight.FareList[0].Checkin}/{flight.FareList[0].Cabin}</span>
          </span>
          {/* seats */}
          {/* <span className="inline-flex items-center gap-2 rounded-lg px-3 py-1 text-sm bg-blue-50 border border-blue-200">
            <Armchair size={16} className="text-blue-600" />
            <span className="text-gray-700">{flight.FareList[0].SeatLeft} Left</span>
          </span> */}
          {flight.FareList[0].IsMeal ? (
            <span className="inline-flex items-center text-sm bg-white">
              <Utensils size={16} className="text-green-700" />
              <span className="text-green-700">&nbsp;Free Meal</span>
            </span>
          ) : (
            <span className="inline-flex items-center text-sm bg-white">
              <Utensils size={16} className="text-red-700" />
              <span className="text-red-700">&nbsp;Paid Meal</span>
            </span>
          )}
          {flight.FareList[0].IsRefundable ? (
            <span className="inline-flex items-center text-sm bg-white">
              <TicketCheck size={16} className={`${flight.FareList[0].IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`} />
              <span className={`${flight.FareList[0].IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`}>
                {flight.FareList[0].RefundableTxt}
              </span>
            </span>
          ) : (
            <span className="inline-flex items-center text-sm bg-white">
              <TicketX size={16} className="text-red-600" />
              <span className="text-red-700">
                {flight.FareList[0].RefundableTxt}
              </span>
            </span>
          )}

          {flight.FareList.length > 1 && (
            <button onClick={() => setOpen((v) => !v)} className="text-sm font-medium text-[#1ea9e0] hover:underline">
              {open ? "Show Less" : `+${flight.FareList.length - 1} More fares`}
            </button>
          )}
        </div>


        <button
          onClick={() => handlFlightDeatils(flight, flight.FareList[0])}
          className="text-sm text-right font-medium text-[#1ea9e0] hover:underline"
        // onClick={(e) => e.stopPropagation()}
        >
          {flight.FareList[0].is_flexi && (
            <p className="text-sm text-blue-600 ">
              Book at ₹{flight.FareList[0].BookAmt.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
            </p>
          )}
          Flight Details
        </button>
      </div>


      {open && flight.FareList.map((value, Farekey) => (
        Farekey > 0 && (
          <div
            key={value.PriceID}
            className={`grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 items-center gap-2 p-2 mt-2 border-t`}
          >
            {/* Left side (3 cols combined) */}
            <div className="col-span-3 flex items-center gap-2 flex-wrap">
              <div className="flex items-center border rounded-lg hover:bg-gray-50">
                <input
                  checked={isFlightSelected(flight, value?.PriceID)}
                  value="1"
                  type="checkbox"
                  onClick={() => handleShareSelection(flight, value.PriceID, !isFlightSelected(flight, value?.PriceID))}
                  className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
              </div>
              <span className="inline-flex items-center gap-2 border rounded-lg px-3 py-1 text-sm bg-blue-50 border-blue-200">
                <Ticket size={16} className="text-blue-600" />
                <span className="text-gray-700">
                  {value.fareIdentifier}
                </span>
              </span>

              {value.IsMeal ? (
                <span className="inline-flex items-center text-sm bg-white">
                  <Utensils size={16} className="text-green-600" />
                  <span className="text-green-600">Free Meal</span>
                </span>
              ) : (
                <span className="inline-flex items-center text-sm bg-white">
                  <Utensils size={16} className="text-red-600" />
                  <span className="text-red-600">Paid Meal</span>
                </span>
              )}

              <span className="inline-flex items-center text-sm bg-white">
                <BaggageClaim size={16} className="text-gray-600" />
                <span className="text-gray-600">{value.Checkin}/{value.Cabin}</span>
              </span>

              {value.IsRefundable ? (
                <span className="inline-flex items-center text-sm bg-white">
                  <TicketCheck size={16} className={`${value.IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`} />
                  <span className={`${value.IsRefundable == 1 ? "text-green-600" : "text-orange-600"}`}>
                    {value.RefundableTxt}
                  </span>
                </span>
              ) : (
                <span className="inline-flex items-center text-sm bg-white">
                  <TicketX size={16} className="text-red-600" />
                  <span className="text-red-600">
                    {value.RefundableTxt}
                  </span>
                </span>
              )}
            </div>

            {/* Price + Details (1 col) */}
            <div className="text-right">
              {FormData.GroupRequest !== true && (
                <button className="text-lg font-bold">
                  <CurFt
                    currency={value?.symbol || "INR"}
                    price={value.PublishedFare}
                  />
                  {value?.discountOffline > 0 && (
                    <>
                      <span className="inline-flex font-normal line-through items-center gap-2 text-sm text-red-600">
                        <CurFt currency={value?.symbol || "INR"} price={(value.PublishedFare + value?.discountOffline)} />
                      </span>
                      <br />
                    </>
                  )}
                </button>
              )}
              <br />
              <span
                onClick={() => handlFlightDeatils(flight, value)}
                className="text-sm font-medium text-[#1ea9e0] hover:underline cursor-pointer"
              >
                Details
              </span>
            </div>

            {/* Book button (1 col) */}
            <div className="text-right">
              <button
                className="cursor-pointer"
                onClick={() => onSelect({ flight, price: value })}
                role="button"
              >
                <SelectDot selected={selected?.PriceID === value?.PriceID} />
              </button>
            </div>
          </div>
        )
      ))}
    </div>
  );
}

// function BottomTile({ f, className = "" }) {
//   return (
//     <div className={`flex items-center gap-4 ${className}`}>
//       <div className="w-12 h-12 rounded-xl overflow-hidden bg-white/10 flex items-center justify-center p-1 shrink-0">
//         <img src={f.logo} alt={f.airline} className="object-contain w-full h-full" />
//       </div>
//       <div className="min-w-0">
//         <p className="font-semibold">{f.airline}</p>
//         <p className="text-xs text-gray-300">{f.code}</p>
//       </div>

//       <div className="hidden md:flex items-center gap-8 text-sm">
//         <TileCol top={format(new Date(f.FromUTCTime), "HH:mm")} bottom={f.SoCity} />
//         <TileCol top={format(new Date(f.ToUTCTime), "HH:mm")} bottom={f.DeCity} />
//         <TileCol top={f.Duration} bottom={`${f.StopCount}`} stacked />
//         <TileCol top={String(f.PubFare)} bottom="INR" />
//       </div>
//     </div>
//   );
// }

function BottomTile({ f, FormData }) {
  return (
    <div className="flex items-center gap-4 shrink-0">
      {/* Logo + airline name & flight number */}
      <div className="flex items-center gap-2 min-w-0">
        <div className="w-10 h-10 rounded-md overflow-hidden bg-white/10 flex items-center justify-center p-1 flex-shrink-0">
          <img src={f.flight.logo} alt={f.flight.airline} className="object-contain rounded-md w-full h-full" />
        </div>

        <div className="min-w-0">
          <p className="font-semibold text-sm truncate">{f.flight.airline}</p>
          <p className="text-xs text-gray-300 truncate">{f.flight.code}</p>
        </div>
      </div>

      {/* Times + Cities + duration + fare */}
      <div className="flex items-center gap-4 text-sm">
        {/* From: time above, city below */}
        <div className="flex flex-col items-center min-w-[60px]">
          <span className="font-semibold">{format(new Date(f.flight.FromUTCTime), "HH:mm")}</span>
          <span className="text-xs text-gray-300">{f.flight.SoCity}</span>
        </div>

        {/* Arrow */}
        <div className="text-gray-300">→</div>

        {/* To: time above, city below */}
        <div className="flex flex-col items-center min-w-[60px]">
          <span className="font-semibold">{format(new Date(f.flight.ToUTCTime), "HH:mm")}</span>
          <span className="text-xs text-gray-300">{f.flight.DeCity}</span>
        </div>

        {/* Duration & stops */}
        <div className="flex flex-col items-center min-w-[60px]">
          <span className="text-sm">{f.flight.Duration}</span>
          <span className="text-xs text-gray-300">
            {f.StopCount} {Number(f.flight.StopCount) === 1 ? "stop" : "stops"}
          </span>
        </div>

        {/* Fare */}
        <div className="min-w-[70px]">
          {FormData.GroupRequest !== true && (
            <span className="font-semibold"><CurFt currency={f.price.symbol || "INR"} price={f.price.PublishedFare} /></span>
          )}
        </div>
      </div>
    </div>
  );
}
function TileCol({ top, bottom, stacked }) {
  return (
    <div className="text-center">
      <div className="text-2x2 font-bold leading-5">{top}</div>
      {stacked ? (
        <div className="text-xs text-gray-300 whitespace-pre-line">{bottom}</div>
      ) : (
        <div className="text-xs text-gray-300">{bottom}</div>
      )}
    </div>
  );
}
